export enum AuthenticationState {
    Login,
    LoginOtp,
    ForgottenPassword,
    PasswordReset,
    ForcedPasswordReset,
    ForcedPasswordResetOtp,
}
